export const diagnosisItems = [
  { field: "copd", id: "COPD", name: "COPD" },
  { field: "heartFailure", id: "HEART_FAILURE", name: "Heart Failure" },
  { field: "stroke", id: "STROKE", name: "Cerebrovascular Disease Stroke" },
  { field: "diabetesType2", id: "DIABETES_TYPE_2", name: "Diabetes Type 2" },
  { field: "asthma", id: "ASTHMA", name: "Asthma" },
  { field: "tia", id: "TIA", name: "Cerebrovascular Disease TIA" },
  { field: "ischaemicHeartDisease", id: "ISCHAEMIC_HEART_DISEASE", name: "Ischaemic Heart Disease" },
  { field: "atrialFibrillation", id: "ATRIAL_FIBRILLATION", name: "Atrial Fibrillation" },
];
